import { EventTypes } from 'redux-segment';

import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import { TOGGLE_CALENDAR_SYNC_FAILURE, TOGGLE_CALENDAR_SYNC_REQUEST, TOGGLE_CALENDAR_SYNC_SUCCESS } from './toggleCalendarSync.types';

const ATAG = 'toggleCalendarSync';
const L = logger(ATAG);

// Toggles the sync on/off
const toggleCalendarSync = L.wrap('()', (options) => {
  const { stylistId, salonId, syncEnabled } = asObject(options);

  return {
    ATAG,
    [AUTH_API]: {
      ...authenticatedEndpoint(),
      ...jsonEndpoint(H.put, `salon/${salonId}/stylist/${stylistId}/calendar/`, { allow_sync: syncEnabled }),
      types: [TOGGLE_CALENDAR_SYNC_REQUEST, TOGGLE_CALENDAR_SYNC_SUCCESS, TOGGLE_CALENDAR_SYNC_FAILURE],
      params: { stylistId },
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: syncEnabled ? 'CalendarSyncEnabled' : 'CalendarSyncDisabled',
          properties: { syncEnabled, stylistId, salonId },
        },
      },
    },
  };
});

// noinspection JSUnusedGlobalSymbols
export default toggleCalendarSync;
